export const API_BASE_URL = '/api';

export const API_URL_NAMES = {
  'auth:login': '/Auth/login',

  'users:id': '/User/{0}',
  'users:list': '/User',
  'users:list-admin': '/User/userWithAdmin',
  'users:me': '/User/me',

  'roles:list': '/Role',
  'roles:id': '/Role/{0}',

  'permissions:list': '/Permission',

  'companies:list': '/Company',
  'companies:id': '/Company/{0}',
  'companies:db': '/Company/databases',

  // COMPANY LOCAL PROGRAMS
  'company-local-programs:company': '/CompanyLocalProgram/company/{0}',
  'company-local-programs:id': '/CompanyLocalProgram/{0}',
  'company-local-programs:create-update': '/CompanyLocalProgram',
  'company-local-programs:delete': '/CompanyLocalProgram/{0}',
  'company-local-programs:update': '/CompanyLocalProgram/{0}',
  'company-local-programs:list': '/CompanyLocalProgram',

  'branches:list': '/Branch',
  'branches:id': '/Branch/{0}',

  'currencies:list': '/Currency',
  'currencies:id': '/Currency/{0}',

  'branchcashboxes:list': '/BranchCashBox',
  'branchcashboxes:id': '/BranchCashBox/{0}',
  'branchcashboxes:branch': '/BranchCashBox?branchId={0}',

  'poscashboxes:pos': '/PosCashBox?posId={0}',
  'poscashboxes:id': '/PosCashBox/{0}',
  'poscashboxes:list': '/PosCashBox',

  'pos:list': '/Pos',
  'pos:id': '/Pos/{0}',
  'pos:branch': '/Pos/{0}',

  'customer-accounts-for-branches:list': '/Mikro/CustomerAccountsForBranch',
  'mikro-branches:list': '/Mikro/MikroBranches',
  'mikro-poses:list': '/Mikro/MikroPoses',
  'mikro-prices:list': '/Mikro/MikroPrices',
  'mikro-responsibility-centers:list':
    '/Mikro/MikroResponsibilityCenters?mikroBranchId={0}',
  'mikro-warehouses:list': '/Mikro/MikroWarehouses',
  'mikro-currency-rates:list': '/Mikro/GetMikroCurrencyRates',

  'branch-warehouses:list': '/BranchWarehouse?branchId={0}',
  'branch-warehouses:create-update': '/BranchWarehouse',
  'branch-warehouses:id': '/BranchWarehouse/{0}',

  'barkod-tanimlari:listwithparams': '/BarkodTanimlari/GetAll',
  'barkod-tanimlari:listwithbarstokkodu': '/BarkodTanimlari/{0}',
  'barkod-tanimlari:listbystokod': '/BarkodTanimlari/{0}',
  'barkod-tanimlari:create': '/BarkodTanimlari',
  'barkod-tanimlari:update': '/BarkodTanimlari',
  'barkod-tanimlari:delete': '/BarkodTanimlari/{0}',

  'stok-fiyat-degisiklikleri:listwithparams': '/StokFiyatDegisiklikleri/GetAll',
  'stok-fiyat-degisiklikleri:listwithfidstokkod': '/StokFiyatDegisiklikleri/{0}',
  'stok-fiyat-degisiklikleri:create': '/StokFiyatDegisiklikleri',
  'stok-fiyat-degisiklikleri:update': '/StokFiyatDegisiklikleri',
  'stok-fiyat-degisiklikleri:delete': '/StokFiyatDegisiklikleri/{0}',

  'stok-kategorileri:listwithparams': '/StokKategorileri/GetAll',
  'stok-kategorileri:list': '/StokKategorileri',
  'stok-kategorileri:create': '/StokKategorileri',
  'stok-kategorileri:update': '/StokKategorileri',
  'stok-kategorileri:delete': '/StokKategorileri/{0}',

  'stoklar:listwithparams': '/Stoklar/GetAll',
  'stoklar:id': '/Stoklar/{0}',
  'stoklar:create': '/Stoklar',
  'stoklar:update': '/Stoklar',
  'stoklar:delete': '/Stoklar/{0}',

  'stok-markalari:listwithparams': '/StokMarkalari/GetAll',
  'stok-markalari:list': '/StokMarkalari',
  'stok-markalari:create': '/StokMarkalari',
  'stok-markalari:update': '/StokMarkalari',
  'stok-markalari:delete': '/StokMarkalari/{0}',

  'stok-satis-fiyat-listeleri:listwithparams': '/StokSatisFiyatListeleri/GetAll',
  'stok-satis-fiyat-listeleri:listwithsfiyatstokkod': '/StokSatisFiyatListeleri/{0}',
  'stok-satis-fiyat-listeleri:create': '/StokSatisFiyatListeleri',
  'stok-satis-fiyat-listeleri:update': '/StokSatisFiyatListeleri',
  'stok-satis-fiyat-listeleri:delete': '/StokSatisFiyatListeleri/{0}',

  'stok-satis-fiyat-liste-tanimlari:list': '/StokSatisFiyatListeTanimlari',
  'stok-satis-fiyat-liste-tanimlari:listwithparams':
    '/StokSatisFiyatListeTanimlari/GetAll',
  'stok-satis-fiyat-liste-tanimlari:listwithsfiyatstokkod':
    '/StokSatisFiyatListeTanimlari/{0}',
  'stok-satis-fiyat-liste-tanimlari:create': '/StokSatisFiyatListeTanimlari',
  'stok-satis-fiyat-liste-tanimlari:update': '/StokSatisFiyatListeTanimlari',
  'stok-satis-fiyat-liste-tanimlari:delete': '/StokSatisFiyatListeTanimlari/{0}',

  'stok-sektorleri:listwithparams': '/StokSektorleri/GetAll',
  'stok-sektorleri:list': '/StokSektorleri',
  'stok-sektorleri:create': '/StokSektorleri',
  'stok-sektorleri:update': '/StokSektorleri',
  'stok-sektorleri:delete': '/StokSektorleri/{0}',

  'stok-ureticileri:listwithparams': '/StokUreticileri/GetAll',
  'stok-ureticileri:list': '/StokUreticileri',
  'stok-ureticileri:create': '/StokUreticileri',
  'stok-ureticileri:update': '/StokUreticileri',
  'stok-ureticileri:delete': '/StokUreticileri/{0}',

  'vw-gendata-vergi:list': '/VwGendataVergi',

  'stoklar:listForDataGrid': '/Stoklar/GetAllForDataGrid',

  'mikro-db-sorgulari:listDoviz': '/MikroDBSorgulari/Doviz',
  'mikro-db-sorgulari:listUlkeler': '/MikroDBSorgulari/Ulkeler',
  'mikro-db-sorgulari:listIller': '/MikroDBSorgulari/Iller',
  'mikro-db-sorgulari:listIlceler': '/MikroDBSorgulari/Ilceler',
  'mikro-db-sorgulari:listYerelBankaKodlari': '/MikroDBSorgulari/YerelBankaKodlari',
  'mikro-db-sorgulari:hasCariHesapHareket': '/MikroDBSorgulari/HasCariHesapHareket/{0}',

  'stok-hareketleri:listfordatagrid': '/StokHareketleri/GetAllForDataGrid',

  'cari-hesaplar:listfordatagrid': '/CariHesaplar/GetAllForDataGrid',
  'cari-hesaplar:list': '/CariHesaplar/GetAll',
  'cari-hesaplar:id': '/CariHesaplar/{0}',
  'cari-hesaplar:create': '/CariHesaplar',
  'cari-hesaplar:update': '/CariHesaplar',
  'cari-hesaplar:delete': '/CariHesaplar/{0}',

  'cari-hesap-gruplari:list': '/CariHesapGruplari',
  'cari-hesap-gruplari:create': '/CariHesapGruplari',
  'cari-hesap-gruplari:update': '/CariHesapGruplari',
  'cari-hesap-gruplari:delete': '/CariHesapGruplari/{0}',

  'cari-hesap-adresleri:listbycarikod': '/CariHesapAdresleri/GetByCariKod/{0}',
  'cari-hesap-adresleri:id': '/CariHesapAdresleri/{0}',
  'cari-hesap-adresleri:create': '/CariHesapAdresleri',
  'cari-hesap-adresleri:update': '/CariHesapAdresleri',
  'cari-hesap-adresleri:delete': '/CariHesapAdresleri/{0}',

  'bankalar:listGetAllForDataGrid': '/Bankalar/GetAllForDataGrid',
  'bankalar:id': '/Bankalar/{0}',
  'bankalar:list': '/Bankalar',
  'bankalar:create': '/Bankalar',
  'bankalar:update': '/Bankalar',
  'bankalar:delete': '/Bankalar/{0}',

  'firma-kredi-katri-tanımları:listGetAllForDataGrid':
    '/FirmaKrediKartiTanimlari/GetAllForDataGrid',
  'firma-kredi-katri-tanımları:id': '/FirmaKrediKartiTanimlari/{0}',
  'firma-kredi-katri-tanımları:create': '/FirmaKrediKartiTanimlari',
  'firma-kredi-katri-tanımları:update': '/FirmaKrediKartiTanimlari',
  'firma-kredi-katri-tanımları:delete': '/FirmaKrediKartiTanimlari/{0}',

  'kasalar:listGetAllForDataGrid': '/Kasalar/GetAllForDataGrid',
  'kasalar:id': '/Kasalar/{0}',
  'kasalar:create': '/Kasalar',
  'kasalar:update': '/Kasalar',
  'kasalar:delete': '/Kasalar/{0}',

  'hizmet-hesaplari:listGetAllForDataGrid': '/HizmetHesaplari/GetAllForDataGrid',
  'hizmet-hesaplari:id': '/HizmetHesaplari/{0}',
  'hizmet-hesaplari:create': '/HizmetHesaplari',
  'hizmet-hesaplari:update': '/HizmetHesaplari',
  'hizmet-hesaplari:delete': '/HizmetHesaplari/{0}',

  'masraf-hesaplari:listGetAllForDataGrid': '/MasrafHesaplari/GetAllForDataGrid',
  'masraf-hesaplari:id': '/MasrafHesaplari/{0}',
  'masraf-hesaplari:create': '/MasrafHesaplari',
  'masraf-hesaplari:update': '/MasrafHesaplari',
  'masraf-hesaplari:delete': '/MasrafHesaplari/{0}',

  'hizmet-masraf-gruplari:list': '/HizmetMasrafGruplari',
  'hizmet-masraf-gruplari:create': '/HizmetMasrafGruplari',
  'hizmet-masraf-gruplari:update': '/HizmetMasrafGruplari',
  'hizmet-masraf-gruplari:delete': '/HizmetMasrafGruplari/{0}',

  'hizmet-masraf-siniflari:list': '/HizmetMasrafSiniflari',
  'hizmet-masraf-siniflari:create': '/HizmetMasrafSiniflari',
  'hizmet-masraf-siniflari:update': '/HizmetMasrafSiniflari',
  'hizmet-masraf-siniflari:delete': '/HizmetMasrafSiniflari/{0}',

  'hizmet-masraf-tipleri:list': '/HizmetMasrafTipleri',
  'hizmet-masraf-tipleri:create': '/HizmetMasrafTipleri',
  'hizmet-masraf-tipleri:update': '/HizmetMasrafTipleri',
  'hizmet-masraf-tipleri:delete': '/HizmetMasrafTipleri/{0}',

  'cari-hesap-hareketleri:list': '/CariHesapHareketleriFO/GetAllForDataGrid',
  'stok-hareketleri:list': '/StokHareketleriFO/GetAllForDataGrid',

  'cari-hareket-odeme-vadeleri:list': '/CariHareketOdemeVadeleri/GetAll',

  'depolar:list': '/Depolar',

  //Aktarim
  'aktarim:urunler:list': '/Urun/GetAllPaged',
  'aktarim:satislar:list': '/Satis/GetAllPaged',
  'aktarim:cariler:list': '/Cari/GetAllPaged',
  'aktarim:sayimlar:list': '/Sayim/GetAllPaged',
  'aktarim:alisFaturalar:list': '/AlisFatura/GetAllPaged',
  'aktarim:satisIade:list': '/SatisIade/GetAllPaged',
  'aktarim:cariHareketleri:list': '/Hareket/GetAllPaged',
  'aktarim:takaslar:list': '/Takas/GetAllPaged',
} as const;
